import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "data-list"
  }, _vm._l(_vm.data, function (item) {
    var _item$deserializedInf, _item$deserializedInf2;
    return _c("div", {
      key: item._type,
      staticClass: "data-item"
    }, [_c("div", {
      staticClass: "item-text-wrap"
    }, [_c("div", {
      staticClass: "item-text"
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v("快递单号: ")]), _c("div", {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.deserializedInfo.nu))])]), _c("div", {
      staticClass: "item-text"
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v("快递状态: ")]), _c("div", {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.status))])])]), _c("div", {
      staticClass: "item-text-wrap"
    }, [_c("div", {
      staticClass: "item-text"
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v("快递发出时间: ")]), _c("div", {
      staticClass: "right"
    }, [_vm._v(_vm._s(_vm._f("dateToCNByDayJs")(item.originTime, "YYYY-MM-DD HH:mm:ss")))])]), _c("div", {
      staticClass: "item-text"
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v("快递签收时间: ")]), _c("div", {
      staticClass: "right"
    }, [_vm._v(_vm._s(_vm._f("dateToCNByDayJs")(item.acnldgmtTime, "YYYY-MM-DD HH:mm:ss")))])])]), _c("div", {
      staticClass: "item-text-wrap"
    }, [_c("div", {
      staticClass: "item-text"
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v("快递发出地: ")]), _c("div", {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.originArea) + "(" + _vm._s(item.originLocation) + ")")])])]), _c("div", {
      staticClass: "item-text-wrap"
    }, [_c("div", {
      staticClass: "item-text"
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v("快递起点到终点的直线距离(m): ")]), _c("div", {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.priciseDistance))])]), _c("div", {
      staticClass: "item-text"
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v("地址是否处于规定范围内: ")]), _c("div", {
      staticClass: "right",
      class: [item.isWithinLimit ? "primary" : "red"]
    }, [_vm._v(_vm._s(item.isWithinLimit ? "是" : "否"))])])]), _c("div", {
      staticClass: "item-text-wrap"
    }, [_c("div", {
      staticClass: "item-text"
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v("快递起始→终点: ")]), _c("div", {
      staticClass: "right"
    }, [_c("span", [_vm._v(_vm._s(item === null || item === void 0 || (_item$deserializedInf = item.deserializedInfo) === null || _item$deserializedInf === void 0 || (_item$deserializedInf = _item$deserializedInf.routeInfo) === null || _item$deserializedInf === void 0 || (_item$deserializedInf = _item$deserializedInf.from) === null || _item$deserializedInf === void 0 ? void 0 : _item$deserializedInf.name))]), _c("span", [_vm._v(" → ")]), _c("span", [_vm._v(_vm._s(item === null || item === void 0 || (_item$deserializedInf2 = item.deserializedInfo) === null || _item$deserializedInf2 === void 0 || (_item$deserializedInf2 = _item$deserializedInf2.routeInfo) === null || _item$deserializedInf2 === void 0 || (_item$deserializedInf2 = _item$deserializedInf2.to) === null || _item$deserializedInf2 === void 0 ? void 0 : _item$deserializedInf2.name))])])])]), _c("div", {
      staticClass: "item-text-wrap route-wrap"
    }, [_c("el-collapse", {
      staticClass: "collapse"
    }, [_c("el-collapse-item", {
      attrs: {
        title: "快递详情",
        name: "1"
      }
    }, [_c("div", {
      staticClass: "route-content"
    }, _vm._l(item.deserializedInfo.data, function (route) {
      return _c("div", {
        staticClass: "route-text"
      }, [_c("div", {
        staticClass: "wrap"
      }, [_c("span", {
        staticClass: "time"
      }, [_vm._v(_vm._s(route.time))]), _c("span", {
        staticClass: "status"
      }, [_vm._v("(" + _vm._s(route.status) + ")")])]), _c("div", {
        staticClass: "wrap content"
      }, [_vm._v(_vm._s(route.context))]), route.location || route.areaCenter ? _c("div", {
        staticClass: "item-text"
      }, [_c("div", {
        staticClass: "left"
      }, [_vm._v("坐标: ")]), _c("div", {
        staticClass: "right"
      }, [_vm._v(_vm._s(route.location) + "(" + _vm._s(route.areaCenter) + ")")])]) : _vm._e()]);
    }), 0)])], 1)], 1)]);
  }), 0), _vm.canBeSubmit ? _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("将获取的物流信息写入函证中")])], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };